import { render } from "./PhoneMange.vue?vue&type=template&id=6dff911a&scoped=true"
import script from "./PhoneMange.vue?vue&type=script&lang=js"
export * from "./PhoneMange.vue?vue&type=script&lang=js"

import "./PhoneMange.vue?vue&type=style&index=0&id=6dff911a&lang=scss&scoped=true"
import "./PhoneMange.vue?vue&type=style&index=1&id=6dff911a&lang=scss"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dff911a"]])

export default __exports__